import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '_services/user.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  standalone: false
})
export class TermsComponent {
  dialogRef = inject<MatDialogRef<TermsComponent>>(MatDialogRef);
  userService = inject(UserService);

  calculatorName = '';
  calculatorResult = '';

  constructor() {
    this.calculatorName = this.userService.isAidQuiz ? 'Financial Aid Quiz' : 'Net Price Calculator';
    this.calculatorResult = this.userService.isAidQuiz ? 'Quiz Indicator' : 'Net Price';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

